import { Box, IconButton, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { getImageSrc } from '../../helpers/getImageSrc'
import { CustomFileType } from '../../views/SingleRequestPage/components/SingleRequestDrawer/content/DrawerContentInstallation'

interface UploadedFileProps {
  img: CustomFileType
  deleteFile: (img: CustomFileType) => void
}

const UploadedFileItem = ({ img, deleteFile }: UploadedFileProps) => {
  return (
    <Stack
      direction={'row'}
      spacing={'4px'}
      alignItems={'center'}
      justifyContent={'space-between'}
      sx={wrapperSx}
      key={img.url}
    >
      <Box className={'aln-center'} sx={imgContainerSx}>
        <img
          alt={''}
          src={img.url}
          width={64}
          height={64}
          style={{ objectFit: 'cover' }}
        />
      </Box>
      <Box ml={1.5} className={'aln-center'}>
        <Typography
          variant={'body1'}
          sx={{
            overflowWrap: 'anywhere',
          }}
        >
          {img.file.name}
        </Typography>
      </Box>
      <IconButton
        sx={{ height: '32px', width: '32px' }}
        onClick={() => deleteFile(img)}
      >
        <img alt={''} src={getImageSrc('close')} />
      </IconButton>
    </Stack>
  )
}

const imgContainerSx = {
  borderRadius: '8px',
  border: '1px solid #F6F6F6',
  overflow: 'hidden',
  width: '64px',
  height: '64px',
  minWidth: '64px',
}

const wrapperSx = {
  borderRadius: '8px',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
}

export default observer(UploadedFileItem)
